import { RouteObject } from 'react-router-dom';
import { Landing } from './components/Landing';
import { Create } from './components/create/Create';
import { Landing as OperationDetail } from './components/detail/Landing';

export interface mxOperationsRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: mxOperationsRoute[];
}

export const mxOperationsRoutes: mxOperationsRoute[] = [
  {
    path: 'mx/operations',
    element: <Landing />,
  },
  {
    path: '/mx/operations/create',
    element: <Create />,
  },
  {
    path: '/mx/operations/:operationId',
    element: <OperationDetail />,
  },
];